<template>
  <WdsModal :show="show" lg :title="title" @cancel="$emit('close')">
    <div class="tw-h-[70vh]">
      <!--
        The iframe only exists while shown, so the authenticated (and audited)
        document request fires when the officer or worker actually looks, not
        when the page renders.
      -->
      <iframe
        v-if="show && viewUrl"
        :src="viewUrl"
        :title="title"
        class="tw-w-full tw-h-full tw-border-0 tw-rounded"
        data-test="restricted-document-preview-frame"
      />
    </div>
    <!-- The footer is where the compliance officer's decision lives; plain viewers get a Close button. -->
    <slot name="footer">
      <WdsStack direction-row justify-end gap-sm class="tw-mt-2">
        <WdsButton tertiary @click="$emit('close')">{{ $t('Close') }}</WdsButton>
      </WdsStack>
    </slot>
  </WdsModal>
</template>

<script lang="ts" setup>
import { WdsButton, WdsModal, WdsStack } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

// Inline preview of a restricted document; the iframe source is the authorised route, and PNG/JPEG/PDF all render in it.
defineProps<{
  show: boolean
  viewUrl: string | null
  title: string
}>()

defineEmits<{ close: [] }>()
</script>
